import componentSlider from "../../common/componentSlider.js";
import { initScrolledIntoView } from "../../common/scrollIntoView.js";

export default () => {
  document
    .querySelectorAll(".js-manual-internal-promo-slider")
    .forEach((el, index) => {
      if (
        // Don't init slider for Image Promo Slider variant in Experience Editor
        document.body.classList.contains("is-page-editor") &&
        el.classList.contains(
          "manual-internal-promo-slider--image-promo-slider",
        )
      ) {
        return;
      }

      const config = {};
      const fixedCount = el.hasAttribute("data-leave-gap");
      const numberChildren = el.querySelectorAll(
        ".js-slide-container > *",
      ).length;

      if (el.dataset.slidesToShow) {
        const requestedSlidesToShow = parseInt(el.dataset.slidesToShow, 10); // stricter typing
        config.slidesToShow =
          numberChildren < requestedSlidesToShow && !fixedCount
            ? numberChildren
            : requestedSlidesToShow;
      }

      if (el.dataset.slidesToScroll) {
        config.slidesToScroll = parseInt(el.dataset.slidesToScroll, 10); // stricter typing
      }

      if (el.dataset.showCircles) {
        el.querySelectorAll(".js-quick-stat").forEach((element, i) => {
          element.setAttribute("style", `--animation-order: ${i + 1};`);
        });

        initScrolledIntoView(el, index);
      }

      const breakpoint = 781;
      if (el.dataset.mobileOnly) {
        config.mobileFirst = true;
        config.responsive = [
          {
            breakpoint: breakpoint,
            settings: "unslick",
          },
        ];
      }

      if (document.dir === "rtl" || el.parentElement.dir === "rtl") {
        config.rtl = true;
        el.dataset.isRtl = "true";
      }

      let activeSlider = window.innerWidth < breakpoint;

      const sliderControls = componentSlider(el, config);

      window.addEventListener("resize", () => {
        if (!activeSlider && window.innerWidth < breakpoint) {
          activeSlider = true;
          sliderControls.createSlider();
        }

        if (activeSlider && window.innerWidth >= breakpoint) {
          activeSlider = false;
        }
      });
    });
};
